<template>
    <div class="track-shipment">
        <div class="header-track-shipment">
            <div v-if="cardData && cardData.cards && cardData.cards.elements && cardData.cards.elements.length > 0" class="header-track-inner">
                <p>Current Card Information</p>
            </div>
            <div v-else class="header-track-inner">
                <p>No Card Information</p>
            </div>
        </div>
        <loading-skeleton :loadingHeight="'100px'" v-if="loadingCard" />
    </div>

<!-- Possible Card Types  MASTR-CARD, VISA, DISCOVER, AMEX ACQ-->

<loading-skeleton :loadingHeight="'200px'" v-if="loadingCard"/>
<div v-if="cardData && cardData.cards && cardData.cards.elements && cardData.cards.elements.length > 0" class="card-container">
    <div class="container">
        <div class="card-header">
            <span v-if="cardData.cards.elements[0].cardType == 'VISA'" class="logo">
                <img src="../../../assets/FinalImages/visa.png" alt="">
                <h5>{{cardData.cards.elements[0].cardType}}</h5>
            </span>
            <span v-if="cardData.cards.elements[0].cardType == 'MASTR-CARD'" class="logo">
                <img src="../../../assets/FinalImages/mastercard.png" alt="">
                <h5>{{cardData.cards.elements[0].cardType}}</h5>
            </span>
            <span v-if="cardData.cards.elements[0].cardType == 'DISCOVER'" class="logo">
                <img src="../../../assets/FinalImages/discover.png" alt="">
                <h5>{{cardData.cards.elements[0].cardType}}</h5>
            </span>
            <span v-if="cardData.cards.elements[0].cardType == 'AMEX ACQ'" class="logo">
                <img src="../../../assets/FinalImages/amex.png" alt="">
                <h5>{{cardData.cards.elements[0].cardType}}</h5>
            </span>
            <img src="../../../assets/FinalImages/chip.png" class="chip">
        </div>
        <div class="card-details">
            <div class="name-number">
                <h6>Card Number</h6>
                <h5 class="number">**** **** **** {{cardData.cards.elements[0].last4}}</h5>
                <h5 class="name">{{cardData.firstName}} {{cardData.lastName}}</h5>
            </div>
            <div class="valid-date">
                <h6>Valid Thru</h6>
                <h5>{{cardData.cards.elements[0].expirationDate}}</h5>
            </div>
        </div>
    </div>
</div>

</template>

<script>
import LoadingSkeleton from '../LoadingSkeleton.vue'
export default {
    props:['cardData', 'loadingCard'],
    components:{
        LoadingSkeleton
    }
}
</script>

<style scoped>

.st0{fill:none;stroke:#000000;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;}

.cls-1 {
    fill: none;
    stroke: #3f3f3f;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 10px;
}

.cls-2 {
    fill: none;
    stroke: #000;
    stroke-miterlimit: 10;
    stroke-width: 8px;
}

.track-shipment{
    background-color: #fff;
    padding: 15px;
    border-radius: 25px;
    flex-basis: 25%;
    margin: 10px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.header-track-shipment p{
    font-size: 18px;
    margin: 0;
    margin-left: 10px;
}

.header-track-shipment{
    width: 100%;
    margin-bottom: 5px;
}

.header-track-shipment p{
    font-size: 18px;
    margin: 0;
    margin-left: 10px;
}

.header-track-shipment{
    width: 100%;
    margin-bottom: 5px;
}

.header-track-inner{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: fit-content;
    background-color: #e2e2e2;
    padding: 5px;
    border-radius: 999px;
}

.svg-container{
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
}

.header-track-inner svg{
    height: 18px;
    margin: 0;
}

.user-info{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    text-align: left;
}

.user-info p{
    margin: 0;
}





.card-container{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
}

.container{
    position: relative;
    background-color: #000;
    padding: 15px;
    background-size: cover;
    width: 100%;
    border-radius: 28px;
    max-width: 380px;
    box-shadow: 0 5px 10px rgba(0,0,0,0.1);

}
.card-header,
.logo{
display: flex;
align-items: center;
justify-content: space-between;
}
.logo img{
    width: 65px;
    margin-right: 10px;
}
h5{
    font-size: 16px;
    font-weight: 400;
    color: #fff;
}
.card-header .chip{
    width: 45px;
}
h6{
    color: #fff;
    font-size: 10px;
    font-weight: 400;
}
h5.number{
    margin-top: 4px;
    font-size: 18px;
    letter-spacing: 1px;
}
h5.name{
    margin-top: 20px;
    cursor: pointer;
}
.container .card-details{
    margin-top: 20px;
    display: flex;
    cursor: pointer;

justify-content: space-between;
align-items: flex-end;}






@media only screen and (max-width: 1000px) {
    .track-shipment{
        flex-basis: 40%;
    }
}

@media only screen and (max-width: 600px) {
    .track-shipment{
        flex-basis: 80%;
    }
}
</style>